import { Component, Input } from '@angular/core';

@Component({
	selector: 'skeleton',
	templateUrl: './skeleton.html',
	styleUrls: ['./skeleton.scss']
})
export class Skeleton {
	@Input() height: string = "1em";
	@Input() width: string = "100%";
}
